import { create } from "zustand";

interface RecordingLink {
  _id: string;
  token: string;
  name: string;
  title?: string;
  redirectLink?: string;
  createdBy: {
    _id: string;
    username: string;
    profilePicture: string;
  };
  createdAt: string;
  reports: any[];
  workspace: string;
}

interface RecordingLinksStore {
  recordingLinks: RecordingLink[];
  isLoading: boolean;
  setRecordingLinks: (links: RecordingLink[]) => void;
  addRecordingLink: (link: RecordingLink) => void;
  removeRecordingLink: (linkIdOrToken: string) => void;
  updateRecordingLink: (
    linkIdOrToken: string,
    updates: Partial<RecordingLink>,
  ) => void;
  removeReportFromLink: (reportId: string) => void;
  setIsLoading: (loading: boolean) => void;
  clearRecordingLinks: () => void;
}

const useRecordingLinksStore = create<RecordingLinksStore>((set) => ({
  recordingLinks: [],
  isLoading: false,

  setRecordingLinks: (links) => set({ recordingLinks: links }),

  addRecordingLink: (link) =>
    set((state) => ({
      recordingLinks: [link, ...state.recordingLinks],
    })),

  removeRecordingLink: (linkIdOrToken) => {
    // console.log("Removing recording link:", linkIdOrToken);
    set((state) => {
      const filtered = state.recordingLinks.filter(
        (link) => link._id !== linkIdOrToken && link.token !== linkIdOrToken,
      );
      // console.log(
      //   "Before:",
      //   state.recordingLinks.length,
      //   "After:",
      //   filtered.length
      // );
      return { recordingLinks: filtered };
    });
  },

  updateRecordingLink: (linkIdOrToken, updates) =>
    set((state) => ({
      recordingLinks: state.recordingLinks.map((link) =>
        link._id === linkIdOrToken || link.token === linkIdOrToken
          ? { ...link, ...updates }
          : link,
      ),
    })),

  removeReportFromLink: (reportId) =>
    set((state) => ({
      recordingLinks: state.recordingLinks.map((link) => ({
        ...link,
        reports:
          link.reports?.filter((report: any) => report._id !== reportId) || [],
      })),
    })),

  setIsLoading: (loading) => set({ isLoading: loading }),

  clearRecordingLinks: () => set({ recordingLinks: [] }),
}));

export default useRecordingLinksStore;
